import axios from 'axios'
import React, { useEffect, useState, useCallback } from 'react'
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import DatePicker from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";

function Earings() {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

    const [limit, setLimit] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(0);
    const [EARING, setEARING] = useState([]);
    const [TOTELEARING, setTOTELEARING] = useState(0); 
    const [filteredTotal, setFilteredTotal] = useState(0); 
    const [isFilterApplied, setIsFilterApplied] = useState(false); 

    const [values, setValues] = useState([
        new DateObject().subtract(4, "days"),
        new DateObject()
    ]);

    const fetchData = useCallback(async () => {
        const access_token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${access_token}` };

        let fromDate = values[0] instanceof DateObject ? values[0].format("YYYY-MM-DD") : values[0];
        let toDate = values[1] instanceof DateObject ? values[1].format("YYYY-MM-DD") : values[1];

        try {
            const res = await axios.get(`${baseUrl}admin/Earning?page=${pageNumber}&_limit=${limit}&FROM_DATE=${fromDate}&TO_DATE=${toDate}`, { headers });
            const data = res.data.admin || [];
            setEARING(data);
            setNumberOfPages(res.data.totalPages || 0);

            const totalRes = await axios.get(`${baseUrl}admin/Earning/total`, { headers });
            setTOTELEARING(totalRes.data.total || 0);

            setFilteredTotal(isFilterApplied ? (res.data.totalAmount || 0) : 0);

        } catch (err) {
            console.error("Error:", err);
        }
    }, [baseUrl, pageNumber, limit, values, isFilterApplied]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handlePageClick = async (data) => {
        setPageNumber(data.selected + 1);
    };

    const handleExport = () => {
        const worksheet = XLSX.utils.json_to_sheet(EARING);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Earnings");
        XLSX.writeFile(workbook, "Admin_Earnings.xlsx");
    };

    return (
        <div className="earnings-page-wrapper">
            <style>{`
                .earnings-page-wrapper { background: #f0f2f5; min-height: 100vh; padding: 15px; font-family: 'Poppins', sans-serif; }
                
                /* Header Responsive */
                .earnings-header { 
                    background: #fff; padding: 20px; border-radius: 20px; 
                    box-shadow: 0 10px 30px rgba(0,0,0,0.08); margin-bottom: 20px; 
                    display: flex; flex-direction: column; gap: 15px;
                }
                @media (min-width: 768px) {
                    .earnings-page-wrapper { padding: 30px; }
                    .earnings-header { flex-direction: row; justify-content: space-between; align-items: center; padding: 25px; }
                }

                .earn-badge { padding: 10px 20px; border-radius: 15px; color: white; font-weight: 700; flex: 1; text-align: center; }
                .badge-lifetime { background: linear-gradient(45deg, #57155a, #8e44ad); }
                .badge-filtered { background: linear-gradient(45deg, #27ae60, #2ecc71); }

                /* Filter Card Responsive */
                .filter-card { background: white; padding: 20px; border-radius: 20px; margin-bottom: 20px; box-shadow: 0 5px 15px rgba(0,0,0,0.05); }
                .date-picker-container { width: 100%; margin-bottom: 15px; }
                .modern-date-input { border: 2px solid #e0e0e0; border-radius: 12px; padding: 10px 15px; width: 100%; font-weight: 600; color: #57155a; outline: none; }
                
                .export-btn { background: #57155a; color: white; border: none; padding: 12px 25px; border-radius: 12px; font-weight: 600; cursor: pointer; transition: 0.3s; width: 100%; }
                @media (min-width: 768px) {
                    .date-picker-container { width: auto; margin-bottom: 0; }
                    .export-btn { width: auto; }
                }
                .export-btn:hover { background: #3a0d3c; transform: translateY(-2px); }

                /* Table Responsive Fix */
                .table-container-main { background: white; border-radius: 25px; overflow: hidden; box-shadow: 0 10px 40px rgba(0,0,0,0.05); }
                .table-responsive-wrapper { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; }
                
                .custom-earnings-table { width: 100%; border-collapse: collapse; min-width: 700px; }
                .custom-earnings-table thead { background: #57155a; color: white; }
                .custom-earnings-table th, .custom-earnings-table td { padding: 15px; vertical-align: middle; border: none; text-align: center; }
                
                .custom-earnings-table tbody tr { border-bottom: 1px solid #f0f0f0; }
                
                .text-index { font-weight: 700; color: #57155a; }
                .text-amount { font-weight: 800; color: #27ae60; font-size: 1.1rem; }
                .status-badge-ui { background: #e8f5e9; color: #2e7d32; padding: 6px 14px; border-radius: 10px; font-size: 0.75rem; font-weight: 700; white-space: nowrap; }
                
                .pagination-wrapper { display: flex; justify-content: center; padding: 20px 0; overflow-x: auto; }
                .pagination-ui { display: flex; list-style: none; gap: 5px; padding: 0; }
                .pagination-ui li a { padding: 8px 14px; border-radius: 10px; background: white; color: #57155a; text-decoration: none; border: 1px solid #ddd; font-size: 0.85rem; }
                .pagination-ui li.active a { background: #57155a; color: white; border-color: #57155a; }
            `}</style>

            <div className="earnings-header">
                <div>
                    <h2 style={{fontWeight: 900, color: '#2d3436', margin: 0, fontSize: '1.5rem'}}>Platform <span style={{color: '#57155a'}}>Earnings</span></h2>
                    <p className="text-muted m-0" style={{fontSize: '0.9rem'}}>Live battle commission report</p>
                </div>
                <div className="d-flex gap-2 w-100-mobile" style={{flexWrap: 'wrap'}}>
                    <div className="earn-badge badge-lifetime shadow-sm">
                        <div style={{fontSize: '0.6rem', letterSpacing: '1px'}}>LIFETIME</div>
                        <div style={{fontSize: '1.1rem'}}>₹{TOTELEARING}</div>
                    </div>
                    {isFilterApplied && (
                        <div className="earn-badge badge-filtered shadow-sm">
                            <div style={{fontSize: '0.6rem', letterSpacing: '1px'}}>RANGE</div>
                            <div style={{fontSize: '1.1rem'}}>₹{filteredTotal}</div>
                        </div>
                    )}
                </div>
            </div>

            <div className="filter-card">
                <div className="row align-items-center">
                    <div className="col-12 col-md-6 date-picker-container">
                        <label style={{fontWeight: 700, color: '#2d3436', marginBottom: '8px', display: 'block', fontSize: '0.9rem'}}>Search Date Range</label>
                        <DatePicker 
                            value={values} 
                            onChange={(v) => { setValues(v); setPageNumber(1); setIsFilterApplied(true); }} 
                            range 
                            inputClass="modern-date-input" 
                            format="YYYY-MM-DD"
                            portal
                        />
                    </div>
                    <div className="col-12 col-md-6 text-md-right">
                        <button className="export-btn shadow-sm" onClick={handleExport}>
                           <i className="fa fa-file-excel-o mr-2"></i> Export Data
                        </button>
                    </div>
                </div>
            </div>

            <div className="table-container-main shadow-sm">
                <div className="table-responsive-wrapper">
                    <table className="custom-earnings-table">
                        <thead>
                            <tr>
                                <th style={{width: '10%'}}># INDEX</th>
                                <th style={{width: '40%', textAlign: 'left'}}>TRANSACTION DETAIL</th>
                                <th style={{width: '25%'}}>EARNINGS AMOUNT</th>
                                <th style={{width: '25%'}}>STATUS</th>
                            </tr>
                        </thead>
                        <tbody>
                            {EARING.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <span className="text-index">#{(pageNumber - 1) * limit + (index + 1)}</span>
                                    </td>
                                    <td style={{textAlign: 'left'}}>
                                        <div style={{fontWeight: 600, color: '#2d3436', fontSize: '0.9rem'}}>Commission Earned</div>
                                        <div style={{fontSize: '0.7rem', color: '#888'}}>Battle ID: {item.Earned_Form}</div>
                                    </td>
                                    <td>
                                        <span className="text-amount">₹{item.Ammount}</span>
                                    </td>
                                    <td>
                                        <span className="status-badge-ui">SUCCESS</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {EARING.length === 0 && (
                    <div style={{textAlign: 'center', padding: '40px', color: '#999', fontSize: '1rem'}}>
                        No transactions found.
                    </div>
                )}
            </div>

            {numberOfPages > 1 && (
                <div className="pagination-wrapper">
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        pageCount={numberOfPages}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination-ui"}
                        activeClassName={"active"}
                        forcePage={pageNumber - 1}
                    />
                </div>
            )}
        </div>
    );
}

export default Earings;
